import { parseRobloxGameRankResponse } from '@intelligence/v3/services/robloxGameRank';

import type { RecordItemType } from '@intelligence/components/SearchRecent/type';

export const transRobloxTableDataForSearch = (response: any): RecordItemType[] => {
  const { list } = parseRobloxGameRankResponse(response);

  return list.map((item) => ({
    id: item?.game_id || '',
    imgSrc: item?.cover || '',
    lineOneStr: item?.entity_name || item?.game_id || '-',
    lineTwoStr: item?.publisher || '-',
    showImgTwo: false,
  }));
};
